import { Box, Grid, useTheme } from '@mui/material';
import { map } from 'lodash';
import LoadingSkeleton from 'src/components/common/LoadingSkeleton';

const ListPredictionSkeleton = () => {
  const {
    palette: { divider, primary, background },
    shape: { borderRadius },
  } = useTheme();
  return (
    <Grid container spacing={3}>
      {map(new Array(10).fill(0), () => (
        <Grid item xs={6}>
          <Box
            bgcolor={background.default}
            height={'100%'}
            sx={{
              cursor: 'pointer',
              ':hover': {
                borderColor: primary.main,
              },
            }}
            borderRadius={borderRadius / 2}
            border={'1px solid'}
            borderColor={divider}
            p={2}
          >
            <LoadingSkeleton count={5} height={20} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ListPredictionSkeleton;
